import axios from 'axios'
import { getAPIService } from '../../getServerHost'

export const userDelete = async (payload: number) => {
  const response = await axios.delete(`${getAPIService}/users/${payload}`)
  return response.data
}
